import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubPlaygroundCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb {...props} name="Playground" />;
}
